import { CheckBalanceStepModel, ICheckBalanceStep } from "./CheckBalanceStep.model";
import { CustomizeStepModel, ICustomizeStep } from "./CustomizeStep.model";
import { RegiftCardStateEnum } from "./enums/RegiftCardStateEnum";
import { WorkflowTypeEnum } from "./enums/WorkflowTypeEnum";
import { IRecipientsStep, RecipientsStepModel } from "./RecipientsStep.model";
import { IRegiftCardStep, RegiftCardStepModel } from "./RegiftCardStep.model";
import { IRegiftPaymentStep, RegiftPaymentStepModel } from "./RegiftPaymentStep.model";

export interface IRegiftCard {
    id: string;
    currentState: RegiftCardStateEnum;

    checkBalanceStep: ICheckBalanceStep;
    regiftCardStep: IRegiftCardStep;
    recipientsStep: IRecipientsStep;
    customizeStep: ICustomizeStep;
    paymentStep: IRegiftPaymentStep;
    type: 'IRegiftCard';


    isValid(): boolean;
}

export class RegiftCardModel implements IRegiftCard {
    id = "";
    currentState: RegiftCardStateEnum = RegiftCardStateEnum.CHECK_BALANCE;

    checkBalanceStep: ICheckBalanceStep;
    regiftCardStep: IRegiftCardStep;
    recipientsStep: IRecipientsStep
    customizeStep: ICustomizeStep;
    paymentStep: IRegiftPaymentStep;
    type: 'IRegiftCard';

    constructor(
    ) {
        this.id = "";

        this.checkBalanceStep = new CheckBalanceStepModel();
        this.regiftCardStep = new RegiftCardStepModel();
        this.recipientsStep = new RecipientsStepModel();
        this.customizeStep = new CustomizeStepModel();
        this.paymentStep = new RegiftPaymentStepModel();
    }

    //USED
    isValid(): boolean {
        return (
            CheckBalanceStepModel.validateModel(this.checkBalanceStep)
            && RegiftCardStepModel.validateModel(this.regiftCardStep, this.checkBalanceStep.remainingBalance)
            && RecipientsStepModel.validateModel(this.recipientsStep, WorkflowTypeEnum.REGIFT_CARD)
            && CustomizeStepModel.validateModel(this.customizeStep)
            && RegiftPaymentStepModel.validateModel(this.paymentStep)
        );
    }

    static MapModel(mapFrom: IRegiftCard): RegiftCardModel {
        var mapTo = new RegiftCardModel();

        mapTo.id = mapFrom.id;
        mapTo.currentState = mapFrom.currentState;

        // check balance
        mapTo.checkBalanceStep.giftCardCode = mapFrom.checkBalanceStep.giftCardCode;
        mapTo.checkBalanceStep.remainingBalance = mapFrom.checkBalanceStep.remainingBalance;

        // regift card
        mapTo.regiftCardStep.value = mapFrom.regiftCardStep.value;

        // Recipients
        var recipientsStep = new RecipientsStepModel();
        recipientsStep.isDirty = false;
        recipientsStep.sendBy = mapFrom.recipientsStep.sendBy;
        recipientsStep.senderSameAsRecipient = mapFrom.recipientsStep.senderSameAsRecipient;
        recipientsStep.sendIndividually = mapFrom.recipientsStep.sendIndividually;
        recipientsStep.sendItLater = mapFrom.recipientsStep.sendItLater;
        //recipientsStep.scheduleSendDetails = { ...mapFrom.recipientsStep.scheduleSendDetails };
        recipientsStep.sender = { ...mapFrom.recipientsStep.sender };
        recipientsStep.recipients = [...mapFrom.recipientsStep.recipients];
        mapTo.recipientsStep = { ...recipientsStep };

        if (mapFrom.recipientsStep.scheduleSendDetails.date != null) {
            const timestamp = Date.parse(mapFrom.recipientsStep.scheduleSendDetails.date.toString());
            mapTo.recipientsStep.scheduleSendDetails.date = new Date(timestamp);
        }
        mapTo.recipientsStep.scheduleSendDetails.hour = mapFrom.recipientsStep.scheduleSendDetails.hour;
        mapTo.recipientsStep.scheduleSendDetails.minute = mapFrom.recipientsStep.scheduleSendDetails.minute;

        //mapTo.recipientsStep.isDirty = false;
        //mapTo.recipientsStep.sendBy = mapFrom.recipientsStep.sendBy;
        //mapTo.recipientsStep.senderSameAsRecipient = mapFrom.recipientsStep.senderSameAsRecipient;
        //mapTo.recipientsStep.sendIndividually = mapFrom.recipientsStep.sendIndividually;
        //mapTo.recipientsStep.sendIndividually = mapFrom.recipientsStep.sendIndividually;
        //mapTo.recipientsStep.recipients = [...mapFrom.recipientsStep.recipients];
        //mapTo.recipientsStep.scheduleSendDetails = { ...mapFrom.recipientsStep.scheduleSendDetails };
        //mapTo.recipientsStep.sender = { ...mapFrom.recipientsStep.sender };

        // Customize
        mapTo.customizeStep.isDirty = false;
        mapTo.customizeStep.giftCardUrl = mapFrom.customizeStep.giftCardUrl ?? "";
        mapTo.customizeStep.mediaUrl = mapFrom.customizeStep.mediaUrl ?? "";
        mapTo.customizeStep.personalMessage = mapFrom.customizeStep.personalMessage ?? "";

        // Preview and Pay
        mapTo.paymentStep.isDirty = false;
        mapTo.paymentStep.termsAccepted = false;
        mapTo.paymentStep.paymentDetails.currency = mapFrom.paymentStep.paymentDetails.currency;
        mapTo.paymentStep.paymentDetails.stripeKey = mapFrom.paymentStep.paymentDetails.stripeKey;
        mapTo.paymentStep.paymentDetails.cardAmount = mapFrom.paymentStep.paymentDetails.cardAmount;
        mapTo.paymentStep.paymentDetails.totalAmount = mapFrom.paymentStep.paymentDetails.totalAmount;
        mapTo.paymentStep.paymentDetails.totalFees = mapFrom.paymentStep.paymentDetails.totalFees;

        //console.debug("MapTo Regift", mapTo);
        return mapTo;
    }

}